import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { tokens } from "../styles";

// Underlined tab bar matching project/components/TabBar.tsx. Active tab
// gets the primary green underline + bold text; inactive tabs have plain
// gray text.
//
// `tabs` — [{ key, label }]. `activeKey` and `onChange(key)` drive selection.

const TabBar = ({ tabs = [], activeKey, onChange }) => (
  <View style={styles.wrap}>
    {tabs.map((tab) => {
      const isActive = tab.key === activeKey;
      return (
        <TouchableOpacity
          key={tab.key}
          activeOpacity={0.85}
          onPress={() => onChange(tab.key)}
          style={styles.tab}
        >
          <Text
            variant="title_16"
            style={[
              styles.label,
              isActive ? styles.labelActive : styles.labelInactive,
            ]}
          >
            {tab.label}
          </Text>
          <View
            style={[
              styles.underline,
              isActive ? styles.underlineActive : styles.underlineInactive,
            ]}
          />
        </TouchableOpacity>
      );
    })}
  </View>
);

export default TabBar;

const styles = StyleSheet.create({
  wrap: {
    flexDirection: "row",
    backgroundColor: tokens.surface,
    paddingHorizontal: tokens.spacing.medium,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: tokens.borderLight,
  },
  tab: {
    flex: 1,
    paddingVertical: tokens.spacing.medium,
    alignItems: "center",
  },
  label: { fontSize: 14 },
  labelActive: { color: tokens.textPrimary, fontWeight: "700" },
  labelInactive: { color: tokens.textTertiary, fontWeight: "500" },
  underline: { height: 3, marginTop: tokens.spacing.small, width: "60%" },
  underlineActive: {
    backgroundColor: tokens.primary.bg,
    borderRadius: 2,
  },
  underlineInactive: { backgroundColor: tokens.surface },
});
